module.exports = __webpack_public_path__ + "img/CC.ca5a5dcd.png";